@if (loader) {
  <div class="loader-overlay"></div>
}
@if (loader) {
  <div class="loader-overlay-spinner">
    <span id="loading"></span>
  </div>
}

@if (formGroup && form && form.config && form.config.parts && form.config.parts.length) {
  <div class="wb-quotation wb-formstyle-quotation"
    >
    <!-- ============================ FORM VIEW ============================ -->
    @if (!submitted) {
      <form [formGroup]="formGroup"
        class="wb-quotation-card"
        autocomplete="off"
        >
        <!-- Throw browsers off autocomplete, mirroring the shared order template. -->
        <input autocomplete="off" name="hidden" type="text" style="display:none;">
        <h2 class="wb-quotation-title">{{ 'quotation_title' | translate | ucFirst }}</h2>
        <p class="wb-quotation-subtitle">{{ 'quotation_subtitle' | translate | ucFirst }}</p>
        <div class="wb-quotation-columns">
          <!-- LEFT: TRIP DETAILS (step 1) -->
          <section class="wb-quotation-col wb-quotation-trip">
            <h3 class="wb-quotation-section">
              <span class="wb-quotation-badge">1</span>
              {{ 'trip_details' | translate | ucFirst }}
            </h3>
            <div class="wb-fields wb-order-form-fields">
              <div class="wb-field-container">
                @for (field of tripFields; track field; let fi = $index) {
                  @if (!field.hidden) {
                    <app-field-wrapper
                      [minimumOrderTime]="form.config.minimumOrderTime"
                [className]="'wb-field wb-' + field.type + ' ' + (field.cssclass || '') +
                  (field.halfIndex !== null && field.halfIndex % 2 === 0 ? ' wb-no-margin' : '') +
                  (field.thirdIndex !== null && field.thirdIndex % 3 === 0 ? ' wb-no-margin' : '')"
                      [index]="fi"
                      [field]="field"
                      [formGroup]="formGroup"
                      [part]="tripPart"
                      [mainConfig]="form.config"
                      [activeTab]="activeTab"
                      (checkWorkArea)="checkWorkAreas($event)"
                      (openHelpModal)="toggleHelpModal($event)">
                    </app-field-wrapper>
                  }
                }
              </div>
              <!-- Return-trip requirement (Yes/No) + conditional return date -->
              <div class="wb-quotation-returntrip">
                <span class="wb-summary-name wb-quotation-returntrip-label">
                  {{ 'return_trip_required' | translate | ucFirst }}
                  <span class="wb-field-wrapper-required">*</span>
                </span>
                <div class="wb-quotation-toggle">
                  <button type="button"
                    class="wb-quotation-toggle-option {{ formGroup.controls['returnTrip']?.value === true ? 'wb-active' : '' }}"
                    (click)="setReturnTrip(true)">
                    {{ 'yes' | translate | ucFirst }}
                  </button>
                  <button type="button"
                    class="wb-quotation-toggle-option {{ formGroup.controls['returnTrip']?.value !== true ? 'wb-active' : '' }}"
                    (click)="setReturnTrip(false)">
                    {{ 'no' | translate | ucFirst }}
                  </button>
                </div>
              </div>
              @if (formGroup.controls['returnTrip']?.value === true && returnDateField) {
                <div class="wb-field-container wb-quotation-returndate"
                  >
                  <app-field-wrapper
                    [minimumOrderTime]="form.config.minimumOrderTime"
                    [className]="'wb-field wb-' + returnDateField.type"
                    [index]="0"
                    [field]="returnDateField"
                    [formGroup]="formGroup"
                    [part]="tripPart"
                    [mainConfig]="form.config"
                    [activeTab]="activeTab"
                    (checkWorkArea)="checkWorkAreas($event)"
                    (openHelpModal)="toggleHelpModal($event)">
                  </app-field-wrapper>
                </div>
              }
            </div>
          </section>
          <!-- RIGHT: YOUR DETAILS (step 3) -->
          <section class="wb-quotation-col wb-quotation-details">
            <h3 class="wb-quotation-section">
              <span class="wb-quotation-badge">2</span>
              {{ 'your_details' | translate | ucFirst }}
            </h3>
            <div class="wb-fields wb-order-form-fields">
              <div class="wb-field-container">
                @for (field of contactFields; track field; let fi = $index) {
                  @if (!field.hidden) {
                    <app-field-wrapper
                      [minimumOrderTime]="form.config.minimumOrderTime"
                [className]="'wb-field wb-' + field.type + ' ' + (field.cssclass || '') +
                  (field.property === 'firstName' || field.property === 'lastName' ? ' wb-half-width' : '') +
                  (field.halfIndex !== null && field.halfIndex % 2 === 0 ? ' wb-no-margin' : '') +
                  (field.thirdIndex !== null && field.thirdIndex % 3 === 0 ? ' wb-no-margin' : '')"
                      [index]="fi"
                      [field]="field"
                      [formGroup]="formGroup"
                      [part]="quoteContactPart"
                      [mainConfig]="form.config"
                      [activeTab]="activeTab"
                      (checkWorkArea)="checkWorkAreas($event)"
                      (openHelpModal)="toggleHelpModal($event)">
                    </app-field-wrapper>
                  }
                }
              </div>
            </div>
          </section>
        </div>
        <div class="wb-quotation-actions">
          <button type="button"
            class="wb-quotation-submit {{ buttonstyle === 'squared' ? 'wb-squared' : '' }}"
            (click)="submitQuotation()">
            {{ 'request_quotation' | translate | ucFirst }}
          </button>
        </div>
      </form>
    }
    <!-- ========================= CONFIRMATION VIEW ========================= -->
    @if (submitted) {
      <div class="wb-quotation-card wb-quotation-confirmation">
        <div class="wb-quotation-check">
          <app-svg-icon [icon]="'check'"></app-svg-icon>
        </div>
        <h2 class="wb-quotation-confirmation-title">
          {{ ('quote_confirmation_title' | translate | ucFirst).replace('{name}', confirmation.name) }}
        </h2>
        <p class="wb-quotation-confirmation-text">
          {{ 'quote_confirmation_text' | translate | ucFirst }}
        </p>
        <div class="wb-quotation-email-box">
          <span class="wb-quotation-email-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
              <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 96 0 117.5 0 144v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"/>
            </svg>
          </span>
          <span class="wb-quotation-email-body">
            <strong>{{ 'quote_confirmation_email_title' | translate | ucFirst }}</strong>
            <span>{{ ('quote_confirmation_email_text' | translate | ucFirst).replace('{email}', confirmation.email) }}</span>
          </span>
        </div>
        <div class="wb-quotation-summary">
          @if (confirmation.pickup) {
            <div class="wb-quotation-summary-row">
              <span class="wb-quotation-summary-label">{{ 'label_pickup' | translate | ucFirst }}</span>
              <span class="wb-quotation-summary-value">{{ confirmation.pickup }}</span>
            </div>
          }
          @if (confirmation.dropoff) {
            <div class="wb-quotation-summary-row">
              <span class="wb-quotation-summary-label">{{ 'label_dropoff' | translate | ucFirst }}</span>
              <span class="wb-quotation-summary-value">{{ confirmation.dropoff }}</span>
            </div>
          }
          @if (confirmation.dateTime) {
            <div class="wb-quotation-summary-row">
              <span class="wb-quotation-summary-label">{{ 'label_datetime' | translate | ucFirst }}</span>
              <span class="wb-quotation-summary-value">{{ confirmation.dateTime }}</span>
            </div>
          }
        </div>
        <!-- Points at the dedicated quote/payment page (see quotePageUrl / environment.quotePageUrl);
        hidden until that page's real URL is set. -->
        @if (quotePageUrl) {
          <a [href]="quotePageUrl" target="_blank" rel="noopener"
            class="wb-quotation-submit {{ buttonstyle === 'squared' ? 'wb-squared' : '' }}">
            {{ 'request_quote_go_to_quote_page' | translate | ucFirst }}
          </a>
        }
      </div>
    }
  </div>
}

<!-- Help modal — field-wrapper emits (openHelpModal); mirrors the shared order template. -->
<ngx-smart-modal #helpModal class="help-modal-pane smart-alert-popup" identifier="helpModal{{instanceId}}"
  customClass="nsm-dialog-animation-ttb help-modal-{{helpData.type}}">
  <span (click)="helpModal.close()" class="wb-close"></span>
  <h3>
    <app-svg-icon [icon]="faInfoCircle"></app-svg-icon>
    {{helpData.helpTitleTag | translate | ucFirst}}
  </h3>
  <p [innerHTML]="helpData.helpTextTag | translate | ucFirst"></p>
</ngx-smart-modal>

<!-- The app's own alert — mirrors the shared order template's navigationErrorModal.
Never use the native browser alert(): it blocks all page scripting/events
until dismissed and looks broken embedded in a customer's own website. -->
<ngx-smart-modal #navigationErrorModal identifier="navigationErrorModal{{instanceId}}" customClass="navigation-error nsm-dialog-animation-ttb" class="smart-alert-popup">
  <span (click)="closeNavigationError()" class="wb-close"></span>
  <h3 class="navigate-error-title">
    <app-svg-icon [icon]="faExclamationTriangle" class="navigate-error-icon"></app-svg-icon>
    <div [innerHTML]="navigationError.title | translate | ucFirst"></div>
  </h3>
  <p class="navigate-error-text" [innerHTML]="navigationError.text | translate | ucFirst"></p>
</ngx-smart-modal>
